<script>
import mixin from "@/pages/inspection_reports/forms/mixin";

export default {
  mixins: [mixin],
  props: {
    cylinders: {
      required: true,
    }
  },
  methods: {
    getGroups() {
      return [
        {
          'title': 'Algemene gegevens',
          'name': 'product',
          'component': 'default',
          'values': {
            'product_manufacturer': this.input({type: 'Default', label: 'Fabrikaat', value: this.getValue('product_manufacturer', this.customerProduct.product.manufacture.name)}),
            'product_type': this.input({type: 'Default', label: 'Type', value: this.getValue('product_type', this.customerProduct.product.type.name)}),
            'product_serie_nr': this.input({type: 'Default', label: 'Serienr.', value: this.getValue('product_serie_nr', this.customerProduct.product.serial_number)}),
            'product_toelatingsnr': this.input({type: 'Default', label: 'Toelatingsnr', value: this.getValue('product_toelatingsnr', this.customerProduct.product.type_approval_number)}),
          }
        },
        {
          'title': 'Afzuig eenheid / Nul-Emissie test',
          'name': 'afzuigeenheid',
          'component': 'default',
          'values': {
            'afzuigeenheid_value': this.input({type: 'afzuigeenheid', label: 'Luchtsnelheid m/s', value: this.getValue('afzuigeenheid_value'), option: this.getOptionValue('afzuigeenheid_value'), testValue: this.customerProduct.product.measuring_range.extraction_flow_rate}),
            // 'afzuigeenheid_hose_diameter': this.input({type: 'default', label: 'Slang diameter', value: this.getValue('afzuigeenheid_hose_diameter')}),
          },
        },
        {
          'title': 'Plaats van opstelling',
          'name': 'customer',
          'component': 'hidden',
          'values': {
            'customer_naam': this.input({type: 'Default', label: 'Naam', value: this.getValue('customer_naam', this.customerProduct.customer.name)}),
            'customer_adres': this.input({type: 'Default', label: 'Adres', value: this.getValue('customer_adres', this.customerProduct.customer.address)}),
            'customer_plaats': this.input({type: 'Default', label: 'Plaats', value: this.getValue('customer_plaats', this.customerProduct.customer.city)}),
          }
        },
        {
          'title': 'Omschrijving',
          'name': 'slot',
          'component': 'default',
          'values': {
            'slot_notes': this.input({type: 'textarea', label: 'Opmerkingen', value: this.getValue('common_notes')}),
          }
        }
      ]
    }
  }
}
</script>

<template>
  <FormRenderer
      ref="renderer"
      :inspectionReport="inspectionReport"
      :inspectionReportResponse="inspectionReportResponse"
      :customerProduct="customerProduct"
      :appointmentId="appointmentId"
  />
</template>